import { requestWithAuthorization } from './requestWithAuthorization';
import PortalConfigure from '@/portal-configure';
import { LoginInfo, ErrorInfo } from '@/types/type';

export const updateMenuList = async (
  loginInfo: LoginInfo,
  userAnonymousId: string
): Promise<void> => {
  let error: Error = { name: '', message: '' };
  await requestWithAuthorization
    .post(PortalConfigure.API.UpdateMenu, { ...loginInfo, userAnonymousId })
    .catch((e: Error) => {
      error = e;
    });
  if (error && error.message) {
    const errorInfo: ErrorInfo = {
      code: 'E00002',
      title: 'Error in update menu list',
      message: error.message,
      args: loginInfo,
    };
    error.message = JSON.stringify(errorInfo);
    throw error;
  }
};
